var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block" },
    [
      _c(
        "div",
        { staticClass: "radio", staticStyle: { margin: "10px 0" } },
        [
          _vm._v(" 排序： "),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.reverse_notify_record_time,
                callback: function($$v) {
                  _vm.reverse_notify_record_time = $$v
                },
                expression: "reverse_notify_record_time"
              }
            },
            [
              _c("el-radio", { attrs: { label: true } }, [_vm._v("降冪")]),
              _c("el-radio", { attrs: { label: false } }, [_vm._v("升冪")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-timeline",
        { attrs: { reverse: _vm.reverse_notify_record_time } },
        _vm._l(_vm.notify_record_time, function(item, index) {
          return _c(
            "el-timeline-item",
            { key: index, attrs: { timestamp: item.notify_date_time } },
            [_vm._v(" " + _vm._s(item.notify_message) + " ")]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }